@let feature = (features$ | async) ?? [];

@if (feature.includes('profile-expanded-menu')) {
    <app-profile-popover-trigger [type]="type" />
} @else {
    <a [routerLink]="type === 'salesperson' ? '/profile/change-password' : '/user-profile/change-password'">
        <app-icon class="icon-6 icon-primary" name="mingcute:user-3-line" />
    </a>
}
